export const CREATE_INVENTORY_ITEM = "CREATE_INVENTORY_ITEM";
export const UPDATE_INVENTORY_ITEM = "UPDATE_INVENTORY_ITEM";
export const DELETE_INVENTORY_ITEM = "DELETE_INVENTORY_ITEM";
export const SELECT_INVENTORY_ITEM = "SELECT_INVENTORY_ITEM";
export const FETCH_INVENTORY_ITEMS = "FETCH_INVENTORY_ITEMS";
// export const FETCH_INVENTORY_UNALLOCATED_ITEMS = "FETCH_INVENTORY_UNALLOCATED_ITEMS";


